import { Inject, Injectable } from "@angular/core";
import { EditionsService } from "@carnegie-learning/data-access-cure";
import { EDITIONS_SERVICE } from "@carnegie-learning/data-access-angular-cure";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import * as studentActiveEditionsActions from "../actions/student-active-editions.action";

@Injectable()
export class StudentActiveEditionsEffects {
    constructor(
        private actions$: Actions,
        @Inject(EDITIONS_SERVICE) private editionsService: EditionsService,
    ) {}

    loadStudentActiveEditions$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(studentActiveEditionsActions.LoadStudentActiveEditions)
            )
            .pipe(
                switchMap((action) => {
                    return this.editionsService.getActiveEditions().pipe(
                        map((editions) => editions),
                        map((editions) =>
                            studentActiveEditionsActions.LoadStudentActiveEditionsSuccess(
                                {
                                    payload: editions,
                                }
                            )
                        ),
                        catchError((error) =>
                            of(
                                studentActiveEditionsActions.LoadStudentActiveEditionsFail(
                                    {
                                        payload: error,
                                    }
                                )
                            )
                        )
                    );
                })
            )
    );
}
